(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-recipe-main"] && !Shopify.designMode) return;
  try {
    
    (() => {
        const BOTTOM_GAP = 24
        const fit = sidebar => {
            sidebar.style.setProperty('--sidebar-fit-top', `${window.innerHeight - sidebar.offsetHeight - BOTTOM_GAP}px`)
        }
        const init = () => {
            const sidebars = document.querySelectorAll('.aw-recipe-main__sidebar')
            if (!sidebars.length) return
            const observer = new ResizeObserver(entries => entries.forEach(entry => fit(entry.target)))
            sidebars.forEach(sidebar => observer.observe(sidebar))
            window.addEventListener('resize', () => sidebars.forEach(fit), { passive: true })
        }
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
        else init()
    })()

  } catch(e) { console.error(e); }
})();
})();
